import React from "react"
import PropTypes from "prop-types"
import RangeFilter from "@swipesense/range-filter"
import "./UtilizationRangeFilter.scss"

class UtilizationRangeFilter extends React.PureComponent {
  selected = key => this.props.selected && this.props.selected.includes(key)

  render() {
    const options = [
      { key: "all", selected: this.selected("all"), text: "All Usage" },
      {
        key: "high",
        selected: this.selected("high"),
        text: "High",
        icon: <span className="utilization-range-square high" />,
        children: <span className="range-description">(100%-85%)</span>,
      },
      {
        key: "optimal",
        selected: this.selected("optimal"),
        text: "Optimal",
        icon: <span className="utilization-range-square optimal" />,
        children: <span className="range-description">(85%-60%)</span>,
      },
      {
        key: "low",
        selected: this.selected("low"),
        text: "Low",
        icon: <span className="utilization-range-square low" />,
        children: <span className="range-description">(60%-20%)</span>,
      },
      {
        key: "veryLow",
        selected: this.selected("veryLow"),
        text: "Very Low",
        icon: <span className="utilization-range-square veryLow" />,
        children: <span className="range-description">(20%-0%)</span>,
      },
    ]

    return (
      <div className="UtilizationRangeFilter">
        <RangeFilter options={options} handleChange={this.props.handleChange} />
      </div>
    )
  }
}

Object.defineProperty(UtilizationRangeFilter, "filterRanges", {
  value: new Map(
    Object.entries({
      high: [85, 100],
      optimal: [60, 85],
      low: [20, 60],
      veryLow: [0, 20],
    })
  ),
  writable: false,
  enumerable: true,
  configurable: false,
})

UtilizationRangeFilter.defaultProps = {
  selected: [],
}

UtilizationRangeFilter.propTypes = {
  /* Function that fires when an option is clicked. The key of the specific option is passed as an argument */
  handleChange: PropTypes.func.isRequired,
  selected: PropTypes.arrayOf(
    PropTypes.oneOf(["all", "high", "optimal", "low", "veryLow"])
  ).isRequired,
}

export default UtilizationRangeFilter
